/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmEmailPreference } from "../models/adm-email-preference";
import { SetUserPreferenceRequest } from "../models/set-user-preference-request";
@Injectable({
  providedIn: "root",
})
class UserPreferencesService extends __BaseService {
  static readonly userPreferencesGetAdmEmailPreferencesPath =
    "/api/UserPreferences/AdmEmail";
  static readonly userPreferencesSetPath = "/api/UserPreferences";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  userPreferencesGetAdmEmailPreferencesResponse(): __Observable<
    __StrictHttpResponse<Array<AdmEmailPreference>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/UserPreferences/AdmEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmEmailPreference>>;
      })
    );
  }
  userPreferencesGetAdmEmailPreferences(): __Observable<
    Array<AdmEmailPreference>
  > {
    return this.userPreferencesGetAdmEmailPreferencesResponse().pipe(
      __map((_r) => _r.body as Array<AdmEmailPreference>)
    );
  }

  /**
   * @param request undefined
   */
  userPreferencesSetResponse(
    request: SetUserPreferenceRequest
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/UserPreferences`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  userPreferencesSet(request: SetUserPreferenceRequest): __Observable<Blob> {
    return this.userPreferencesSetResponse(request).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module UserPreferencesService {}

export { UserPreferencesService };
